import { render, staticRenderFns } from "./ClueCounter.vue?vue&type=template&id=0018ed60&scoped=true"
import script from "./ClueCounter.vue?vue&type=script&lang=ts"
export * from "./ClueCounter.vue?vue&type=script&lang=ts"
import style0 from "./ClueCounter.vue?vue&type=style&index=0&id=0018ed60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0018ed60",
  null
  
)

/* custom blocks */
import block0 from "./ClueCounter.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports